import { GameVars } from "../GameVars";
import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
declare var gamezop: any;

export class BootScene extends Phaser.Scene {

    public static currentInstance: BootScene;
    private crossHiddenString: string;
    private crossVisibilityString: string;
    public isGameInitialized: boolean;

    constructor() {

        super("BootScene");
    }

    public preload(): void {

        const urlParams = new URLSearchParams(window.location.search);

        this.load.image("background", urlParams.get("duel") === "true" ? "assets/bg_duels.jpg" : "assets/bg.jpg");
        this.load.image("clashdome_logo", "assets/preloader_box.png");
        this.load.image("replay_text", "assets/text_replay.png");
    }

    public create(): void {
        this.settingPageVisibility();

        BootScene.currentInstance = this;
        GameManager.setCurrentScene(this);
        GameManager.initializeGamezopSdk();
        this.scene.setVisible(false);
        this.addResizeListener();
        this.onOrientationChange(false);
        if (GameVars.currentScene.sys.game.device.os.desktop) {
            GameManager.init();
        } else {
            if (window.innerWidth > window.innerHeight) {
                document.getElementById("rotate").style.display = "block";
                document.getElementById("TOPMOST").style.display = "none";
                this.isGameInitialized = false;
                GameManager.init();
            } else {
                GameManager.init();
                this.isGameInitialized = true;
            }
        }

    }

    private settingPageVisibility() {
        if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
            this.crossHiddenString = "hidden";
            this.crossVisibilityString = "visibilitychange";
            // @ts-ignore
        } else if (typeof document.msHidden !== "undefined") {
            this.crossHiddenString = "msHidden";
            this.crossVisibilityString = "msvisibilitychange";
            // @ts-ignore
        } else if (typeof document.webkitHidden !== "undefined") {
            this.crossHiddenString = "webkitHidden";
            this.crossVisibilityString = "webkitvisibilitychange";
        }
    }
    private addResizeListener() {
        document.addEventListener(this.crossVisibilityString, () => {
            this.handleVisibilityChange();
        }, false);
        window.addEventListener("resize", () => {
            this.onOrientationChange();
        });
    }

    private handleVisibilityChange() {
        //@ts-ignore
        if (document[this.crossHiddenString]) {
            gamezop.mute();
        } else {
            gamezop.unmute();
        }
    }

    private onOrientationChange(shouldWeCheckSdkFunctions: boolean = true) {
        let width: number;
        let height: number;
        if (/iPhone/.test(navigator.userAgent)) {
            width = document.documentElement.clientWidth;
            height = document.documentElement.clientHeight;
        } else {
            width = window.innerWidth;
            height = window.innerHeight;
        }
        if (width > height) {
            if (!isMobile.any()) {
                return;
            }
            document.getElementById("rotate").style.display = "block";
            if (shouldWeCheckSdkFunctions) {
                // gamezop.pause();
                gamezop.mute();
            }
        } else {
            document.getElementById("rotate").style.display = "none";
            if (shouldWeCheckSdkFunctions) {
                if (!this.isGameInitialized) {
                    this.isGameInitialized = true;
                    // GameManager.init();
                    // GameManager.startGame();
                }
                // gamezop.play();
                gamezop.unmute();
            }
        }
    }
}

const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function () {
        return (
            isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera()
            || isMobile.Windows()
        );
    }
};
